var render, staticRenderFns
import script from "./ThgImpactSelectorOnlyPayout.vue?vue&type=script&lang=ts&"
export * from "./ThgImpactSelectorOnlyPayout.vue?vue&type=script&lang=ts&"
import style0 from "./ThgImpactSelectorOnlyPayout.vue?vue&type=style&index=0&id=e5b73354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b73354",
  null
  
)

export default component.exports